var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KTPortlet',{scopedSlots:_vm._u([{key:"toolbar",fn:function(){return undefined},proxy:true},{key:"body",fn:function(){return [_c('QOffer',{key:_vm.offersKey,on:{"reset":function($event){_vm.offersKey += 1}}},[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.$t("NEW_QUICK_OFFER.SUB_TITLE")))])],2)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }